import CategoryTemplate from './category.template'

export default CategoryTemplate
